import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
} from "react-bootstrap";
import { SingleDatePicker } from "react-dates";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import * as groupsActions from "actions/groupsActions";

class PlanHourlyOpener extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.state = {
			date: this.props.start || "",
			group_id: this.props.group_id || "",
			isLoading: false,
			submitted: false,
			error: "",
		};
	}

	componentDidMount() {
		this.props.getAllGroups();
	}

	onDateChange = (date) => {
		const formattedDate = date ? date.format("YYYY-MM-DD") : "";

		this.setState({
			date: formattedDate,
		});
	};

	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	checkInvalidDate = () => {
		return (
			this.state.submitted &&
			(this.state.date === "" ||
				this.state.date === null ||
				this.state.error !== "")
		);
	};

	// open plan
	handleSubmit = async (event) => {
		event.preventDefault();
		const { group_id, date, error } = this.state;
		const props = this.props;

		if (group_id && date && error === "") {
			// Para vista hourly, start y end son el mismo día
			const newURL = `/plans/${group_id}/${date}@${date}`;
			window.history.pushState(null, "", newURL);
			props.updateStateAndReload({ group_id, start: date, end: date });
			props.handleClose();
		}

		this.setState({
			submitted: true,
			error,
		});
	};

	render() {
		const { error, date, group_id, submitted } = this.state;
		const { detailed_groups } = this.props;

		const optionGroupList =
			detailed_groups.length > 0 &&
			detailed_groups.map((item, i) => {
				let multigroup = item.is_multigroup ? " (multigrupo)" : "";
				return (
					<option key={i} value={item.id}>
						{item.name}
						{multigroup}
					</option>
				);
			}, this);
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body plan-opener-modal">

					<FormGroup className="form-group" controlId="group_id">
						<FormLabel>{this.props.t('planHourlyOpener.group')}</FormLabel>
						<FormControl
							value={group_id}
							onChange={this.handleChange}
							isInvalid={submitted && group_id === ""}
							as="select"
						>
							<option value="">{this.props.t('planHourlyOpener.selectGroup')}</option>
							{optionGroupList}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{this.props.t('planHourlyOpener.selectGroupRequired')}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup
						className={`form-group-periodo ${this.checkInvalidDate() ? "is-invalid" : ""
							}`}
					>
						<FormLabel>{this.props.t('planHourlyOpener.day')}</FormLabel>
						<SingleDatePicker
							date={date ? moment(date) : null}
							onDateChange={this.onDateChange}
							focused={this.state.focused}
							onFocusChange={({ focused }) => this.setState({ focused })}
							id="single-date-picker"
							placeholder={this.props.t('planHourlyOpener.selectDay')}
							hideKeyboardShortcutsPanel={true}
							isOutsideRange={() => false}
							numberOfMonths={1}
						/>
						<FormControl
							className="hidden"
							isInvalid={this.checkInvalidDate()}
						/>

						<FormControl.Feedback type="invalid">
							{error !== "" ? error : this.props.t('planHourlyOpener.selectDayRequired')}
						</FormControl.Feedback>
					</FormGroup>

					{this.state.error_footer && (
						<InlineAlert variant="error" className="mt15">
							{this.state.error_footer}
						</InlineAlert>
					)}

					{/* {this.state.errors && this.state.errors.plan_id && (
						<div
							className="alert alert-danger alert-general-error fade show"
							role="alert"
						>
							{this.state.errors.plan_id}
						</div>
					)} */}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t('planHourlyOpener.open')}
						loadingText={this.props.t('planHourlyOpener.opening')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};


const mapDispatchToProps = (dispatch) => ({
	getAllGroups: () =>
		dispatch(
			groupsActions.getAllGroups({ sort: "+name", variant: "detailed" })
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(PlanHourlyOpener)));
